import { DynamicComponent } from '@gik/core/components/DynamicComponent';
import { useIsMounted } from '@gik/core/hooks/hooks/useIsMounted';
import type { WordpressTaxonomy } from '@gik/core/models/wordpress/WordpressTaxonomy';
import type { UIComponent } from '@gik/core/types/UI';
import bemBlock from '@gik/core/utils/bemBlock';
import React from 'react';
import { GiveFooter } from '../GiveFooter/GiveFooter';
import { GiveHeader } from '../GiveHeader/GiveHeader';

export type GivePageLayoutProps = {
  taxonomyItem?: WordpressTaxonomy;
} & UIComponent;

export function GivePageLayout({
  taxonomyItem,
  children,
  className,
}: React.PropsWithChildren<GivePageLayoutProps>): React.ReactElement {
  const bem = bemBlock('give-page-layout');

  const isMounted = useIsMounted();

  return (
    <div className={bem(null, null, className)}>
      <GiveHeader taxonomyItem={taxonomyItem} />
      {children}
      {isMounted() && (
        <DynamicComponent height={560}>
          <GiveFooter />
        </DynamicComponent>
      )}
    </div>
  );
}
